





import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getAdminUserTasksApi, getMyTasksApi } from "../../../app/api";
import { createPortal } from "react-dom";
import TaskSubtasks from "../../../components/Tasks/TaskSubtasks";
import UserMonthlyTasks from "./UserTaskBoard";

const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

export default function UserTaskBoard() {
  const { id } = useParams();

  const [showMonthlyTasks, setShowMonthlyTasks] = useState(false);



  const navigate = useNavigate();
  const [selectedTask, setSelectedTask] = useState(null);


  const [expandedTasks, setExpandedTasks] = useState([]);

  const toggleDescription = (taskId) => {
    setExpandedTasks((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId]
    );
  };

  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (id) {
      loadTasks();
    }
  }, [id]);

  const loadTasks = async () => {
    try {
      const loggedUser = JSON.parse(localStorage.getItem("user"));
      const isOwnProfile = Number(loggedUser?.id) === Number(id);

      const res = isOwnProfile 
        ? await getMyTasksApi()
        : await getAdminUserTasksApi(id);

      if (res.success) {
        setTasks(res.data);
      } else {
        toast.error("Failed to load tasks");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  // ✅ Safe Creator Name Getter
  const getCreatorName = (task) => {
    if (typeof task.creator === "string") return task.creator;
    if (typeof task.creator === "object") return task.creator?.name || "";
    return "";
  };

  // ✅ Safe Creator Image Getter
  const getCreatorImage = (task) => {
    return task.creator_profile_pic || task.creator?.profile_pic || null;
  };

  const columns = [
    { title: "New Task", key: "TODO", border: "border-t-blue-500", bg: "bg-[#050B1A]" },
    { title: "In Progress", key: "IN_PROGRESS", border: "border-t-cyan-400", bg: "bg-[#032432]" },
    { title: "Pending", key: "PENDING", border: "border-t-[#fb8110]", bg: "bg-[#1A0D02]" },
    { title: "Complete", key: "DONE", border: "border-t-[#28B07E]", bg: "bg-[#072319]" },
  ];

  return (
    <div className="min-h-screen bg-[#1b153f] p-8 md:mt-24 mt-20 rounded-[20px]">
  
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-white">
          Monthly Tasks
        </h2>
  
        <button
          onClick={() => navigate(-1)}
          className="bg-white/10 text-white px-4 py-2 rounded-lg text-sm hover:bg-white/20 transition"
        >
          ← Back
        </button>
      </div>
  
      {/* ✅ ONLY THIS */}
      <UserMonthlyTasks userId={id} />
  
    </div>
  );
}


function SubtaskModal({ task, onClose }) {
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white w-[500px] max-w-[95%] p-6 rounded-xl shadow-2xl">
        
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-semibold text-lg">
            Subtasks - {task.title}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-black"
          >
            ✕
          </button>
        </div>

        <TaskSubtasks taskId={task.id} />

      </div>
    </div>,
    document.body
  );
}



// import { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// // import { getAllTasksApi } from "../../../app/api";
// import { toast } from "react-toastify";
// import { getAdminUserTasksApi } from "../../../app/api";


// const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

// export default function UserTaskBoard() {
//   const { id } = useParams();
//   const [tasks, setTasks] = useState([]);

//   useEffect(() => {
//     loadTasks();
//   }, [id]);

//   const loadTasks = async () => {
//     const res = await getAdminUserTasksApi(id);
  
//     if (res.success) {
//       setTasks(res.data);
//     } else {
//       toast.error("Failed to load tasks");
//     }
//   };
  
//   const columns = [
//     {
//       title: "New Task",
//       key: "TODO",
//       border: "border-t-blue-500",
//       bg: "bg-[#050B1A]",
//     },
//     {
//       title: "In Progress",
//       key: "IN_PROGRESS",
//       border: "border-t-cyan-400",
//       bg: "bg-[#032432]",
//     },
//     {
//       title: "Pending",
//       key: "PENDING",
//       border: "border-t-[#fb8110]",

//       bg: "bg-[#1A0D02]",
//     },
//     {
//       title: "Complete",
//       key: "DONE",
//       border: "border-t-[#28B07E]",
//       bg: "bg-[#072319]",
//     },
//   ];

//   return (

//     // <div className="min-h-screen bg-[#1b153f] p-8 mt-20"> <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"></div>
//     <div className="min-h-screen bg-[#1b153f] p-8 md:mt-24 rounded-[20px]">
//           {/* 🌫 Background Floating Light */}
//           <div className="absolute top-20 left-20 w-72 h-72 bg-white/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
//         <div className="absolute bottom-10 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
  
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

//         {columns.map((col) => {
//           const filtered = tasks.filter(
//             (task) => task.status === col.key
//           );

//           return (
//             <div
//               key={col.key}
//             //   className={`rounded-2xl p-4 border-t-4 ${col.border} ${col.bg} shadow-xl`}
//             className={`rounded-2xl border-t-4 ${col.border} ${col.bg} shadow-xl flex flex-col h-[600px] `}

            
//             >
//               {/* Column Header */}
//               <div className="flex justify-between items-center  p-4">
//                 <h3 className="text-white font-semibold">
//                   {col.title}
//                 </h3>
//                 <button className="text-white bg-white/10 px-2 py-1 rounded-md text-xs">
//                   +
//                 </button>
//               </div>

//               {/* Tasks */}
//               <div className="flex-1 overflow-y-auto px-4 pb-4 space-y-4 no-scrollbar scroll-smooth">


//               {filtered.length === 0 ? (
//                 <p className="text-gray-400 text-sm">
//                   No tasks
//                 </p>
//               ) : (
//                 filtered.map((task) => (
//                   <div
//                     key={task.id}
//                     className="relative rounded-xl p-4 mb-5 bg-[#282B44] border border-[#2c3a4f] shadow-md hover:bg-[#243244] transition-all duration-300"
//                     >
//                     {/* Title */}
//                     <h4 className="text-white font-semibold text-sm">
//                       {task.title}
//                     </h4>

//                     {/* Description */}
//                     <p className="text-gray-400 text-xs mt-2 line-clamp-2">
//                       {task.description}
//                     </p>

//                     {/* Dates */}
//                     <div className="flex justify-between text-[10px] text-gray-400 mt-3">
//                       <div>
//                         <p>Start</p>
//                         <p className="text-gray-300">
//                           {task.startDate}
//                         </p>
//                       </div>
//                       <div>
//                         <p>End</p>
//                         <p className="text-gray-300">
//                           {task.endDate}
//                         </p>
//                       </div>
//                     </div>

//                     {/* Progress Bar */}
//                     <div className="h-1 bg-gray-700 rounded-full mt-3">
//                       <div
//                         className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full"
//                         style={{
//                           width:
//                             task.status === "DONE"
//                               ? "100%"
//                               : task.progress
//                               ? `${task.progress}%`
//                               : "40%",
//                         }}
//                       />
//                     </div>

//                     {/* Bottom Row */}
//                     <div className="flex items-center justify-between mt-3">
//                       {/* Profile Pic */}
//                       <div className="flex items-center gap-2">
//                       {task.creator_profile_pic || task.creator?.profile_pic ? (
//   <img
//     src={`${IMAGE_BASE_URL}${
//       task.creator_profile_pic || task.creator?.profile_pic
//     }`}
//     alt=""
//     className="w-7 h-7 rounded-full object-cover border border-white/20"
//   />
// ) : (
//   <div className="w-7 h-7 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs">
//     {typeof task.creator === "string"
//       ? task.creator.charAt(0)
//       : task.creator?.name?.charAt(0)}
//   </div>
// )}
//                         <span className="text-xs text-gray-300">
//                           {task.creator}
//                         </span>
//                       </div>

//                       {/* Status Badge */}
//                       <span
//                         className={`text-[10px] px-2 py-1 rounded-full font-medium
//                         ${
//                           task.status === "DONE"
//                             ? "bg-green-500/20 text-green-400"
//                             : task.status === "IN_PROGRESS"
//                             ? "bg-cyan-500/20 text-cyan-400"
//                             : task.status === "PENDING"
//                             ? "bg-orange-500/20 text-orange-400"
//                             : "bg-blue-500/20 text-blue-400"
//                         }`}
//                       >
//                         {task.status}
//                       </span>
//                     </div>
//                   </div>
//                 ))
//               )}
//             </div>
//             </div>

//           );
//         })}

//       </div>
//     </div>
//   );
// }
